webpackJsonp([20,39,40,42,43],{

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("37e7c3c6", content, true, {});

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SlideImage1.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SlideImage1.l.scss": 1089,
	"./SlideImage1.m.scss": 1091,
	"./SlideImage1.s.scss": 1093,
	"./SlideImage1.scss": 1095
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1088;

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1090);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1092);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1094);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1096);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1097:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contents)?[_c('div',{class:['component', _vm.previewSize],style:(_vm.hideAll ? 'display:none' : '')},[_c('div',{on:{"click":function($event){_vm.isEditing = !_vm.isEditing}}},[_c('section',{class:_vm.sectionClassArray,style:(_vm.sectionStyle)},[_c('div',{class:_vm.containerClassArray},[_c('div',{class:['amp-img', 'slide-img', 'amp-img-cover', _vm.contents.image.width > _vm.contents.image.height ? 'landscape' : 'portrait']},[_c('mimic-amp-img',{attrs:{"image":_vm.contents.image}})],1)])])])]),_vm._v(" "),_c('el-dialog',{attrs:{"width":"90%","title":"画像の選択","visible":_vm.dialogImageSelectVisible},on:{"update:visible":function($event){_vm.dialogImageSelectVisible=$event}}},[_c('select-image',{on:{"change":_vm.onUpdateImage},model:{value:(_vm.selectedImage),callback:function ($$v) {_vm.selectedImage=$$v},expression:"selectedImage"}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogImageSelectVisible = false}}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdateImage}},[_vm._v("選択")])],1)],1),_vm._v(" "),_c('el-form',{class:['component-contents-form', ' p2', _vm.lock ? 'hide' : _vm.isEditing ? 'show' : 'hide'],attrs:{"model":_vm.contents}},[_c('h2',[_vm._v("コンポーネントのコンテンツを編集")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"コンポーネント配置順序","label-width":"170px"}},[_c('el-input-number',{attrs:{"controls-position":"right","min":1,"max":_vm.positionMax},model:{value:(_vm.newPosition),callback:function ($$v) {_vm.newPosition=$$v},expression:"newPosition"}}),_c('span',{staticClass:"pl4"},[_vm._v("1から"+_vm._s(_vm.positionMax)+"まで")])],1),_vm._v(" "),_c('el-form-item',[_c('el-checkbox',{model:{value:(_vm.contents.fullWidth),callback:function ($$v) {_vm.$set(_vm.contents, "fullWidth", $$v)},expression:"contents.fullWidth"}},[_vm._v("画像を最大幅で表示する")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"リンク先URL","label-width":_vm.labelWidth}},[_c('el-input',{staticClass:"width-75",attrs:{"auto-complete":"off"},model:{value:(_vm.contents.link.href),callback:function ($$v) {_vm.$set(_vm.contents.link, "href", $$v)},expression:"contents.link.href"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-checkbox',{model:{value:(_vm.contents.link.blank),callback:function ($$v) {_vm.$set(_vm.contents.link, "blank", $$v)},expression:"contents.link.blank"}},[_vm._v("リンク先を新たなタブで開く")])],1),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.onSelectImage(_vm.contents.image)}}},[_vm._v("画像の選択")]),_vm._v(" "),_c('div',{staticClass:"image-info flex column justify-between items-center"},[_c('img',{staticClass:"image-info-img",attrs:{"src":_vm.contents.image.src}}),_vm._v(" "),_c('p',{staticClass:"image-info-size"},[_vm._v("画像のサイズ："+_vm._s(_vm.contents.image.width)+"x"+_vm._s(_vm.contents.image.height))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド上下の余白","label-width":_vm.labelWidth}},[_c('el-slider',{attrs:{"step":1,"min":0,"max":10},model:{value:(_vm.contents.padding.y),callback:function ($$v) {_vm.$set(_vm.contents.padding, "y", $$v)},expression:"contents.padding.y"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.bg.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.bg, "isCustom", $$v)},expression:"contents.bg.isCustom"}},[_vm._v("スライドの背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.bg.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.bg.color),callback:function ($$v) {_vm.$set(_vm.contents.bg, "color", $$v)},expression:"contents.bg.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.bg.color))])],1)]),_vm._v(" "),_c('div',{staticClass:"component-contents-controller flex justify-end items-center"},[_c('component-form-footer',{on:{"delete":function($event){_vm.deleteComponent()},"cancel":function($event){_vm.isEditing = false},"update":function($event){_vm.updateComponent()}}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e587aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'component-form-footer': __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__["default"]
  },
  data: function data() {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    };
  },

  props: {
    index: { type: Number, default: null },
    bus: { type: Object, default: null },
    positionMax: { type: Number, default: null },
    component: { type: Object, default: null },
    components: { type: Array, default: null },
    hideAll: { type: Boolean, default: false },
    lock: { type: Boolean, default: false },
    previewSize: { type: String, default: 'native' },
    inPreview: { type: Boolean, default: false }
  },
  computed: {
    contents: {
      get: function get() {
        return this.component.contents;
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    meta: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].components[this.component.id].meta;
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    },
    sectionId: {
      get: function get() {
        return this.componentId(this);
      }
    },
    sectionClass: {
      get: function get() {
        return this.meta.file + ' ' + this.meta.file + '-' + this._uid + ' ' + (this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + ' slide';
      }
    },
    sectionClassArray: {
      get: function get() {
        return [this.meta.file, 'slide', 'theme-base-bg-color'];
      }
    },
    sectionStyle: {
      get: function get() {
        return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
      }
    },
    containerClass: {
      get: function get() {
        return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '');
      }
    },
    containerClassArray: {
      get: function get() {
        return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y];
      }
    },
    gridClass: {
      get: function get() {
        return 'grid grid-mx' + this.contents.layout.margin + ' grid-my' + this.contents.layout.margin + ' grid-1-' + this.contents.layout.s + ' grid-1-' + this.contents.layout.m + '-m grid-1-' + this.contents.layout.l + '-l';
      }
    },
    gridClassArray: {
      get: function get() {
        return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'];
      }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function componentId(that) {
      return that.component ? that.component.meta.file + '-' + that._uid : that.meta.file + '-' + that._uid;
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function getPageById(id) {
      return this.pages.find(function (page) {
        return page.id === id;
      });
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function getSubPagesById(id) {
      return this.pages.filter(function (page) {
        return page.parent === id && page.status === 'publish';
      });
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function updateComponent() {
      if (false) console.log('Running updateComponent of ' + this.name + '...');

      this.component.html = this.generateHtml(this.component.contents);
      this.component.css = this.generateCss(this.component.contents);
      this.$emit('update', { component: this.component, newPosition: this.newPosition });
      this.isEditing = false;
    },

    updateComponentUid: function updateComponentUid() {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (false) console.log('%c_uid has been changed: ' + this.component._uid + ' -> ' + this._uid, 'color:blue');
        this.bus.$emit('uid-updated', this);
        this.component._uid = this._uid;
        if (false) console.log('%c_uid has been updated: this.component._uid = ' + this.component._uid, 'color:teal');
      }
    },

    updateComponentAndUid: function updateComponentAndUid() {
      this.updateComponentUid();
      this.updateComponent();
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function deleteComponent() {
      this.$emit('delete');
      this.isEditing = false;
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function created() {
    if (!this.component._uid) this.component._uid = this._uid;
    if (this.component.uid) delete this.component.uid;
    this.updateComponent();
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function mounted() {
    this.$emit('mounted');
    this.bus.$on('update-child', this.updateComponentAndUid);
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__ = __webpack_require__(455);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e0f36de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectImage_vue__ = __webpack_require__(458);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28312d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectImage_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28312d60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28312d60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideImage1_vue__ = __webpack_require__(811);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_942658c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideImage1_vue__ = __webpack_require__(1097);
function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-942658c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideImage1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_942658c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideImage1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-form-footer',
  methods: {
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onUpdate: function onUpdate() {
      this.$emit('update');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("727fe8b8", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ComponentFormFooter.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.onDelete()}}},[_vm._v("削除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdate}},[_vm._v("適用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mimic-amp-img',
  props: ['image']
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'select-image',
  props: ['value'],
  data: function data() {
    return {
      selected: { id: 0 }
    };
  },
  // watch: {
  //   /**
  //    * @see https://stackoverflow.com/questions/40915436/vuejs-update-parent-data-from-child-component/40915910
  //    */
  //   selected: function (newVal, oldVal) {
  //     console.log('%cnewValue = ' + JSON.stringify(newVal), 'color:red')
  //     console.log('%coldValue = ' + JSON.stringify(oldVal), 'color:red')
  //     this.selected.id = newVal.id
  //     this.$emit('input', this.selected)
  //   }
  // },
  computed: {
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    }
  },
  created: function created() {
    if (false) console.log('On SelectImage created...');
    // if (process.env.NODE_ENV !== 'production') console.log(this.media)
    // if (process.env.NODE_ENV !== 'production') console.log(this.media.map(image => image.id))
    // if (process.env.NODE_ENV !== 'production') console.log(this.media.map(image => image.media_details.sizes.thumbnail))

    this.selected = this.value;
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("2434fe00", content, true, {});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".amp-img[data-v-7e0f36de]{display:block;width:100%;position:relative;overflow:hidden!important}.amp-img-sizer[data-v-7e0f36de]{display:block!important}.amp-img-content[data-v-7e0f36de]{display:block;margin:auto;border:none!important;padding:0!important;width:0;max-width:100%;min-width:100%;height:0;max-height:100%;min-height:100%;position:absolute;top:0;left:0;right:0;bottom:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/mimic-amp/MimicAmpImg.vue"],"names":[],"mappings":"AAsBA,0BACE,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,yBAA4B,CAC7B,AACD,gCACI,uBAA0B,CAC7B,AACD,kCACI,cAAe,AACf,YAAa,AACb,sBAAwB,AACxB,oBAAsB,AACtB,QAAS,AACT,eAAgB,AAChB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,QAAU,CACb","file":"MimicAmpImg.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.amp-img[data-v-7e0f36de] {\n  display: block;\n  width: 100%;\n  position: relative;\n  overflow: hidden !important;\n}\n.amp-img-sizer[data-v-7e0f36de] {\n    display: block !important;\n}\n.amp-img-content[data-v-7e0f36de] {\n    display: block;\n    margin: auto;\n    border: none !important;\n    padding: 0 !important;\n    width: 0;\n    max-width: 100%;\n    min-width: 100%;\n    height: 0;\n    max-height: 100%;\n    min-height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amp-img"},[_c('div',{staticClass:"amp-img-sizer",style:('padding-top:' + _vm.image.height / _vm.image.width * 100 + '%')}),_vm._v(" "),_c('img',{staticClass:"amp-img-content",attrs:{"src":_vm.image.src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("b7ba9072", content, true, {});

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".image[data-v-28312d60]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.image-list[data-v-28312d60]{border:1px solid #ddd;height:180px;min-height:50vh;overflow:scroll}.image-item-input[data-v-28312d60]{display:none}.image-item-input:checked+.image-item-label[data-v-28312d60]:after{border:3px solid #569cf3}.image-item-label[data-v-28312d60]{display:block;width:139px;height:139px;position:relative}.image-item-label[data-v-28312d60]:after{content:\"\";display:block;width:100%;height:100%;position:absolute;top:0;left:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/app/SelectImage.vue"],"names":[],"mappings":"AAsBA,wBACE,WAAY,AACZ,YAAa,AACb,oBAAqB,AAClB,gBAAkB,CACtB,AACD,6BACI,sBAAuB,AACvB,aAAc,AACd,gBAAiB,AACjB,eAAiB,CACpB,AACD,mCACI,YAAc,CACjB,AACD,mEACM,wBAA0B,CAC/B,AACD,mCACI,cAAe,AACf,YAAa,AACb,aAAc,AACd,iBAAmB,CACtB,AACD,yCACM,WAAY,AACZ,cAAe,AACf,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACb","file":"SelectImage.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.image[data-v-28312d60] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.image-list[data-v-28312d60] {\n    border: 1px solid #ddd;\n    height: 180px;\n    min-height: 50vh;\n    overflow: scroll;\n}\n.image-item-input[data-v-28312d60] {\n    display: none;\n}\n.image-item-input:checked + .image-item-label[data-v-28312d60]:after {\n      border: 3px solid #569cf3;\n}\n.image-item-label[data-v-28312d60] {\n    display: block;\n    width: 139px;\n    height: 139px;\n    position: relative;\n}\n.image-item-label[data-v-28312d60]:after {\n      content: \"\";\n      display: block;\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.media)?[_c('ul',{staticClass:"image-list flex wrap"},[_vm._l((_vm.media),function(image,index){return [_c('li',{key:index,staticClass:"image-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected.id),expression:"selected.id"}],staticClass:"image-item-input",attrs:{"type":"radio","id":_vm._uid + '-' + image.id},domProps:{"value":image.id,"checked":_vm._q(_vm.selected.id,image.id)},on:{"change":function($event){_vm.$set(_vm.selected, "id", image.id)}}}),_vm._v(" "),_c('label',{staticClass:"image-item-label",attrs:{"for":_vm._uid + '-' + image.id}},[_c('img',{staticClass:"image",attrs:{"src":image.media_details.sizes.thumbnail.source_url}})])])]})],2)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_ComponentBase__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mimic_amp_MimicAmpImg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_SelectImage__ = __webpack_require__(135);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slide-with-image',
  components: {
    'mimic-amp-img': __WEBPACK_IMPORTED_MODULE_3__components_mimic_amp_MimicAmpImg__["default"],
    'select-image': __WEBPACK_IMPORTED_MODULE_4__components_app_SelectImage__["default"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_ComponentBase__["default"]],
  data: function data() {
    return {
      labelWidth: '11em',
      selectedImage: {
        id: null,
        src: null,
        width: null,
        height: null
      },
      dialogImageSelectVisible: false
    };
  },
  watch: {
    selectedImage: function selectedImage(newVal) {
      console.log(newVal);
    }
  },
  methods: {
    /**
     * 「画像の選択」ボタンがクリックされたら、contents.imageの各プロパティを
     * this.selectedImageにコピーする
     */
    onSelectImage: function onSelectImage(image) {
      var found = this.media.find(function (img) {
        return img.source_url === image.src;
      });
      if (false) console.log(found);
      image.id = found ? found.id : 0;

      this.selectedImage.id = image.id;
      this.selectedImage.src = image.src;
      this.selectedImage.width = image.width;
      this.selectedImage.height = image.height;
      this.dialogImageSelectVisible = true;
    },
    /**
     * ダイアログで画像を選択したら、選択した画像をidを元にthis.mediaから探し、
     * その画像の情報をthis.contents.imageに格納する
     */
    onUpdateImage: function onUpdateImage() {
      var _this = this;

      var selected = this.media.find(function (image) {
        return image.id === _this.selectedImage.id;
      });
      this.contents.image.id = selected.id;
      this.contents.image.src = selected.source_url;
      this.contents.image.width = selected.media_details.width;
      this.contents.image.height = selected.media_details.height;
      this.dialogImageSelectVisible = false;
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function generateHtml(contents) {
      var imageDirection = contents.image.width > contents.image.height ? 'landscape' : 'portrait';
      var ampImage = '<amp-img class="slide-img amp-img-cover ' + imageDirection + '" width="' + contents.image.width + '" height="' + contents.image.height + '" layout="responsive" src="' + contents.image.src + '"></amp-img>';

      var anchor = '';
      if (contents.link.href) {
        anchor += '<a class="SlideImage1-a block" href="' + contents.link.href + '" ' + (contents.link.blank ? 'target=_blank' : '') + '>' + ampImage + '</a>';
      } else {
        anchor += '<div>' + ampImage + '</div>';
      }

      return ('\n      <section id="' + this.sectionId + '" class="' + this.sectionClass + '">\n        <div class="' + this.containerClass + '">\n          ' + anchor + '\n        </div>\n      </section>\n      ').trim().replace(/>\s+</g, '><');
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function generateCss(contents) {
      var layout = __webpack_require__(1088)("./" + this.meta.file + '.scss');
      var theme = contents.bg.isCustom ? '.' + this.meta.file + '-' + this._uid + '-bg{background-color:' + contents.bg.color + '}' : '';
      return { layout: layout, theme: theme };
    }
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // migration
              if (!this.contents.padding) this.contents.padding = { y: 0 };

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }()
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.39954e75b9e8c13ee203.js